import { SongStatusType } from 'types/song';

interface SongStatusColor {
  background: string;
}

export const chakraSongStatusColorEnum: Record<
  SongStatusType,
  SongStatusColor
> = {
  [SongStatusType.IN_CREATION]: {
    background: 'P.0',
  },
  [SongStatusType.PITCHABLE]: {
    background: 'B.0',
  },
  [SongStatusType.HOLD]: {
    background: 'O.0',
  },
  [SongStatusType.RELEASED]: {
    background: 'G.0',
  },
};
